export default "__VITE_ASSET__DlM_725n__"